/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Nbstatechangep13Inputs */



/**
* | output |
* | --- |
* | "Number of state changes left/high pump" |
*
* @param {Br_History_Key_Nbstatechangep13Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_nbstatechangep13 = /** @type {((inputs?: Br_History_Key_Nbstatechangep13Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Nbstatechangep13Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Number of state changes left/high pump")
	return /** @type {LocalizedString} */ ("Nombre de changements d'état pompe gauche/haute")
});
export { br_history_key_nbstatechangep13 as "br_history_key_nbStateChangeP1" }